// extracted by mini-css-extract-plugin
export var changeIcon = "_5q-4";
export var container = "_5q-0";
export var divider = "_5q-7";
export var externalLinkIcon = "_5q-1";
export var green = "_5q-5";
export var helpCircleIcon = "_5q-3";
export var iconButton = "_5q-2";
export var red = "_5q-6";